import { LeftOutlined } from '@ant-design/icons';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as Style from './BackButton.style';

interface Props {
  to?: string;
  onClick?: () => void;
}

const BackButton: React.FC<Props> = ({ to, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Style.BackButton type="text" onClick={handleClick}>
      <LeftOutlined />
      <span>BACK</span>
    </Style.BackButton>
  );
};

export default BackButton;
